import { Action } from '@ngrx/store';
import { PriceListForm } from './state-models/price-list-form';
import { PriceType } from './state-models/price-list-form';
import { variantCodeValues } from '../production-price-list/state-models/production-price-condition';

export enum PriceListFormActionType {
  LoadPriceTypeListAction = '[ PriceListForm ] Load Price Types',
  LoadVariantCombinationListAction = '[ PriceListForm ] Load Variant Combinations'
}

export class LoadPriceTypeListAction implements Action {
  readonly type = PriceListFormActionType.LoadPriceTypeListAction;
  constructor(public payload: PriceType[]) { }
}

export class LoadVariantCombinationListAction implements Action {
    readonly type = PriceListFormActionType.LoadVariantCombinationListAction;
    constructor(public payload: variantCodeValues[]) { }
}



export type PriceListFormAction =
  | LoadPriceTypeListAction
  | LoadVariantCombinationListAction;
